var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 0.241699C4.49379 0.241699 0 4.7358 0 10.2417C0 15.7479 4.4941 20.2417 10 20.2417C15.5062 20.2417 20 15.7476 20 10.2417C20 4.73549 15.5059 0.241699 10 0.241699ZM10 19.0698C5.13215 19.0698 1.17188 15.1096 1.17188 10.2417C1.17188 5.37385 5.13215 1.41357 10 1.41357C14.8679 1.41357 18.8281 5.37385 18.8281 10.2417C18.8281 15.1096 14.8679 19.0698 10 19.0698Z",
    fill: "#FF3131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.02832 15.7998C5.35192 15.7998 5.61426 15.5375 5.61426 15.2139C5.61426 14.8903 5.35192 14.6279 5.02832 14.6279C4.70472 14.6279 4.44238 14.8903 4.44238 15.2139C4.44238 15.5375 4.70472 15.7998 5.02832 15.7998Z",
    fill: "#FF3131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.9717 5.85547C15.2953 5.85547 15.5576 5.59314 15.5576 5.26953C15.5576 4.94593 15.2953 4.68359 14.9717 4.68359C14.6481 4.68359 14.3857 4.94593 14.3857 5.26953C14.3857 5.59314 14.6481 5.85547 14.9717 5.85547Z",
    fill: "#FF3131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.614 4.85521C4.38518 5.08404 4.38518 5.45502 4.614 5.68385C4.84283 5.91268 5.21381 5.91268 5.44264 5.68385C5.67146 5.45502 5.67146 5.08404 5.44264 4.85521C5.21385 4.62639 4.84283 4.62639 4.614 4.85521Z",
    fill: "#FF3131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.5574 14.7996C14.3285 15.0284 14.3285 15.3994 14.5574 15.6282C14.7862 15.857 15.1572 15.857 15.386 15.6282C15.6148 15.3994 15.6148 15.0284 15.386 14.7996C15.1572 14.5707 14.7862 14.5707 14.5574 14.7996Z",
    fill: "#FF3131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10 4.96826C10.3236 4.96826 10.5859 4.70592 10.5859 4.38232V3.21045C10.5859 2.88686 10.3236 2.62451 10 2.62451C9.67641 2.62451 9.41406 2.88686 9.41406 3.21045V4.38232C9.41406 4.70592 9.67641 4.96826 10 4.96826Z",
    fill: "#FF3131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10 15.5151C9.67641 15.5151 9.41406 15.7775 9.41406 16.1011V17.2729C9.41406 17.5965 9.67641 17.8589 10 17.8589C10.3236 17.8589 10.5859 17.5965 10.5859 17.2729V16.1011C10.5859 15.7775 10.3236 15.5151 10 15.5151Z",
    fill: "#FF3131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M4.72656 10.2417C4.72656 9.91811 4.46422 9.65576 4.14062 9.65576H2.96875C2.64516 9.65576 2.38281 9.91811 2.38281 10.2417C2.38281 10.5653 2.64516 10.8276 2.96875 10.8276H4.14062C4.46422 10.8276 4.72656 10.5653 4.72656 10.2417Z",
    fill: "#FF3131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M15.2734 10.2417C15.2734 10.5653 15.5358 10.8276 15.8594 10.8276H17.0312C17.3548 10.8276 17.6172 10.5653 17.6172 10.2417C17.6172 9.91811 17.3548 9.65576 17.0312 9.65576H15.8594C15.5358 9.65576 15.2734 9.91811 15.2734 10.2417Z",
    fill: "#FF3131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M10.5859 9.999V6.72607C10.5859 6.40248 10.3236 6.14014 10 6.14014C9.67641 6.14014 9.41406 6.40248 9.41406 6.72607V10.2417C9.41406 10.3971 9.47582 10.5461 9.5857 10.656L13.1013 14.1717C13.3301 14.4004 13.7011 14.4005 13.93 14.1717C14.1588 13.9428 14.1588 13.5719 13.93 13.343L10.5859 9.999Z",
    fill: "#FF3131"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard4);
export default __webpack_public_path__ + "static/media/card-4.8357de0f80a19155d1999a2f6e9c5caf.svg";
export { ForwardRef as ReactComponent };